import { render } from "./ServicePriceFormModal.vue?vue&type=template&id=47bc33a0"
import script from "./ServicePriceFormModal.vue?vue&type=script&lang=js"
export * from "./ServicePriceFormModal.vue?vue&type=script&lang=js"

import exportComponent from "/builds/phi-indonesia/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__